import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import Image from 'next/image';

const Marker = () => {
    return (
        <div className="aimed-marker">
            <FullWrapper isMargin={false}>
                <div className="aimed-markerWrapper">
                    <div className="aimed-markerTitle">Уникальный разметчик</div>
                    <div className="aimed-markerFramesList">
                        <div className="aimed-markerFrameItem">
                            <Image
                                src="/images/pic/aimed/f2.png"
                                alt="marker"
                                width={840}
                                height={557}
                                className="aimed-markerImg"
                            />
                        </div>
                        <div className="aimed-markerFrameItem">
                            <Image
                                src="/images/pic/aimed/f1.png"
                                alt="marker"
                                width={840}
                                height={379}
                                className="aimed-markerImg"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Marker;
